import React from 'react';
import { Button, Form } from 'react-bootstrap';
import PropTypes from 'prop-types';
import classNames from 'classnames';

export const MinusPlusInput = ({
  handleChangeCarac,
  name,
  title,
  quantity,
  noCenter
}) => (
  <div
    className={classNames({
      'text-center': !noCenter
    })}
  >
    <Form.Label
      className={classNames({
        'fs--1': !noCenter
      })}
    >
      {title}
    </Form.Label>

    <div
      className={classNames('caracteristicas__box', {
        'w-100': !noCenter,
        'd-flex': !noCenter,
        'justify-content-center': !noCenter
      })}
    >
      <Button
        variant="falcon-default"
        className="rounded-pill me-2 py-0 px-2"
        size="sm"
        onClick={e => handleChangeCarac(e, name, 'rest')}
      >
        -
      </Button>

      <span className="caracteristicas__quantity">{quantity}</span>

      <Button
        variant="falcon-default"
        className="rounded-pill ms-2 px-2 py-0"
        size="sm"
        onClick={e => handleChangeCarac(e, name, 'add')}
      >
        +
      </Button>
    </div>
  </div>
);

MinusPlusInput.propTypes = {
  handleChangeCarac: PropTypes.func,
  name: PropTypes.string,
  title: PropTypes.string,
  quantity: PropTypes.number,
  noCenter: PropTypes.bool
};
